// import axios, { AxiosError, AxiosPromise, AxiosProxyConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';

// ------------- AXIOS DEFAULTS SETTINGS -------------
// ---------------------------------------------------
// const defaultURL = 'http://127.0.0.1:8000/api/';
const defaultURL = 'https://api.amaanarabia.com/api/';

axios.defaults.baseURL = defaultURL;
